<!-- FT-194 REQ-06: тумблер модуля «Аренда с выкупом» в филиале — на вкладке «Аренда» настроек филиала. -->
<template>
  <div v-if="visible" data-testid="rto-settings-card">
    <v-divider class="my-4" />
    <h3 class="mb-2">
      {{ $t("rent_to_own.settings.title") }}
      <BetaChip />
    </h3>
    <v-switch
      v-model="enabled"
      :loading="saving"
      :disabled="saving || formDirty"
      :label="$t('rent_to_own.settings.switch')"
      hide-details
      data-testid="rto-settings-switch"
      @change="save"
    />
    <div v-if="formDirty" class="text-caption warning--text mt-1" data-testid="rto-settings-save-tab-first">
      {{ $t("rent_to_own.settings.save_tab_first") }}
    </div>
    <div class="text-caption mt-1">
      {{ $t("rent_to_own.settings.hint") }}
      <a :href="helpUrl" target="_blank" rel="noopener" data-testid="rto-settings-help">{{ $t("rent_to_own.settings.help") }}</a>
    </div>
    <v-alert v-if="refusal" type="warning" dense outlined class="mt-3" data-testid="rto-settings-refusal">
      {{ refusal.text }}
      <router-link v-if="refusal.contracts" to="/rent_to_own/contracts">{{ $t("rent_to_own.settings.open_contracts") }}</router-link>
    </v-alert>
  </div>
</template>

<script>
import { rentToOwnApi, rentToOwnInPlan, parseRentToOwnError, storeCompany } from "@/api/rentToOwn";
import { docsBase } from "@/utils/docsSite";
import { docsUrl } from "@/utils/stageCard";

export const HELP_PATH = "/arenda-s-vykupom/nachalo";

// Видна при услуге в плане и роли superadmin/admin (без услуги — скрыта, решение USER U4). Сохраняется сразу своим
// запросом (не через saveCompany, вне dirtyTracker), на время запроса неактивна. Явный отказ API — откат и причина;
// сетевой сбой или неизвестный ответ (результат неизвестен) — филиал перечитывается, тумблер показывает значение сервера.
export default {
  name: "RentToOwnSettingsCard",
  props: {
    // Вкладка «Аренда» с несохранёнными правками: запись переключателя рассылает филиал целиком (CompanyChannel), и
    // рассылка заменила бы объект формы — тумблер ждёт сохранения вкладки (code review FT-194).
    formDirty: { type: Boolean, default: false },
  },
  data() {
    return { enabled: false, saving: false, refusal: null };
  },
  computed: {
    company() {
      return storeCompany(this.$store.getters) || {};
    },
    // FT-205: сайт справки по стране филиала и языку интерфейса; пересчитывается, когда филиал загрузится.
    helpUrl() {
      return docsUrl(docsBase(this.company, this.$i18n?.locale), HELP_PATH);
    },
    visible() {
      return this.company.id != null && rentToOwnInPlan(this.$store.getters.getMainCompany) && this.isAdminPlus;
    },
  },
  watch: {
    "company.rent_to_own_on": {
      immediate: true,
      handler(value) {
        if (!this.saving) this.enabled = value === true;
      },
    },
  },
  methods: {
    async save(value) {
      this.saving = true;
      this.refusal = null;
      try {
        const data = await rentToOwnApi.updateSettings(this.axios, value);
        this.$store.commit("setCompany", { company: { ...this.company, rent_to_own_on: data.rent_to_own_on === true } });
      } catch (err) {
        await this.handleFailure(err);
      } finally {
        this.saving = false;
        this.enabled = this.company.rent_to_own_on === true;
      }
    },
    async handleFailure(err) {
      const parsed = parseRentToOwnError(err);
      const body = (err && err.response && err.response.data) || {};
      if (body.error === "live_contracts") {
        this.refusal = { text: this.$t("rent_to_own.settings.live_contracts", { count: body.count }), contracts: true };
      } else if (parsed && (parsed.code === "paywall" || parsed.code === "forbidden")) {
        this.refusal = { text: this.$t(parsed.i18nKey) };
      } else {
        // Сеть, 5xx, неизвестный код: результат неизвестен — перечитать филиал.
        try {
          const response = await this.axios.get("/api/v1/company");
          // Только поле переключателя: остальной филиал в сторе — форма вкладки, её не трогаем.
          this.$store.commit("setCompany", { company: { ...this.company, rent_to_own_on: response.data.rent_to_own_on === true } });
        } catch (_reloadError) {
          // филиал не перечитан — тумблер вернётся к значению стора
        }
        this.refusal = { text: this.$t("rent_to_own.settings.unknown_result") };
      }
    },
  },
};
</script>
